import { useTranslation } from 'react-i18next';

import { Button } from '@treezor/design-system';

import { openModal } from '@/store/actions/core.actions';

import { selectProfileByUserId } from '@/store/selectors';
import { useAccesControl } from '@/hooks/useAccessControl';
import { useAppDispatch, useAppSelector } from '@/hooks/redux-helpers';

import { useProfileContext } from '@/features/context/ProfileContext';
import { featuresSlugs } from '@/features/roles/store/models/features.model';

import { ICreateBeneficiaryModalProps } from './AddBeneficiaryModal';

export const AddBeneficiary = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { user } = useProfileContext();
  const { hasAccessToFeature } = useAccesControl();

  const isLoading = useAppSelector(
    (state) => user && selectProfileByUserId(state, user.userId)?.state?.beneficiaries?.create?.isLoading,
  );

  const toggleCreateBeneficiaryModal = () =>
    dispatch(openModal<ICreateBeneficiaryModalProps>('createBeneficiaryModal', { userId: user.userId }));

  if (!hasAccessToFeature(featuresSlugs.CREATE_BENEFICIARY)) return null;

  return (
    <Button
      id="display-create-beneficiary-btn"
      icon="add"
      variant="tertiary"
      onClick={toggleCreateBeneficiaryModal}
      isLoading={isLoading}
      className="ml-auto"
      testId="btn-create-beneficiary"
    >
      {t('pages.currentProfiles.beneficiaries.add.createBtn')}
    </Button>
  );
};
